const createUrl = (brand, type, slug) => {
  let prefix = `/${brand.replace(/\s/g, '').toLowerCase()}/`;

  // temporary fix, other title variants that differ from the known brand may still break.
  // waiting for BE to include slug or original brandName in media-API
  if (brand.includes('Floortje' || 'floortje')) {
    prefix = 'floortje/';
  }

  const typeName = type.toLowerCase();

  if (typeName === 'article') {
    return `${prefix}artikelen/${slug}`;
  }
  if (typeName === 'page') {
    return `${prefix}${slug}`;
  }
  if (typeName === 'video') {
    return `${prefix}videos/${slug}`;
  }
  if (typeName === 'audio') {
    return `${prefix}audio/${slug}`;
  }

  return null;
};

export default createUrl;
